<!-- 设置公共页面，仅做跳转使用 -->
<template>
  <transition name="el-zoom-in-center">
    <router-view :key="key"></router-view>
  </transition>
</template>
<script>
export default {
  computed: {
    key() {
      return this.$route.fullPath
    },
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped></style>
